/**
 * Related products — lazy-loaded via IntersectionObserver.
 * Extracted from sections/related-products.liquid.
 *
 * The product id, recommendations URL and section id are passed via data-*
 * attributes on the <product-recommendations> root.
 */
document.addEventListener('alpine:init', () => {
  Alpine.data('relatedProducts', () => ({
    observer: null,
    productId: '',
    url: '',
    sectionId: '',

    init() {
      const d = this.$el.dataset;
      this.productId = d.productId || '';
      this.url = d.recommendationsUrl || '';
      this.sectionId = d.sectionId || '';
      this.initRecommendations();
    },

    initRecommendations() {
      if (this.observer) {
        this.observer.unobserve(this.$el);
      }
      this.observer = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this.$el);
          this.loadRecommendations();
        },
        { rootMargin: '0px 0px 400px 0px' },
      );
      this.observer.observe(this.$el);
    },

    loadRecommendations() {
      fetch(`${this.url}&product_id=${this.productId}&section_id=${this.sectionId}`)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recs = html.querySelector('product-recommendations');

          if (recs && recs.innerHTML.trim().length) {
            // Replace the current element's content with the fetched recommendations
            this.$el.innerHTML = recs.innerHTML;
          }
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.error(e);
        });
    },
  }));
});
